<template>
  <div class="card-cont">
    <div class="card-in">
      <div class="card-header">
        <div class="card-header-in">
          <div class="icon">
						<i style="font-size:28px;" :class="[icon]"></i>
						<slot name="icon"></slot>
          </div>
          <div class="title card-title">{{cardName}}</div>
					<div class="more">
						<slot name="header"></slot>
					</div>
        </div>
      </div>

			<div style="padding: 20px">
				<slot></slot>
			</div>
    </div>
  </div>
</template>

<script>
export default {
	props: ['cardIcon', 'cardName'],
	computed: {
		icon () {
			return this.cardIcon
		}
	}
}
</script>

<style lang="scss" scoped type="text/css">
.card-cont{
	padding: 20px 0 20px 0;
	box-sizing: border-box;
	max-width: 800px;
	margin: 0 auto;
}
.card-in{
	border-radius: 4px;
	background-color: #fff;
	box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}
// 卡片
.card-header{
	height: 70px;
	position: relative;
	box-sizing: border-box;
	padding: 0 20px;
	.card-header-in{
		position: absolute;
		left: 0;
		bottom: 0px;
		width: 100%;
		box-sizing: border-box;
		padding: 0 20px;
		display: flex;
		.icon{
			position: relative;
			box-sizing: border-box;
			padding: 28px;
			line-height: 32px;
			height: 88px;
			min-width: 88px;
			text-align: center;
			color: #ffffff;
			background-color: #866b93;
			border-radius: 4px;
			font-weight: 700;
			box-shadow: 0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)!important;
			.v-icon{
				color: #fff;
			}
		}
		.more{
			line-height: 32px;
			padding-top: 28px;
			font-size: 24px;
			color: #606266;
		}
		.title{
			box-sizing: border-box;
			flex: 10;
			font-size: 18px;
			padding: 28px;
			height: 88px;
			line-height: 32px;
			font-weight: 300;
		}
	}
}
</style>